// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__3taXK","cancelBtn":"Modal_cancelBtn__15D9_"};